import React, { useState } from "react";
import "./tools.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { UserTypes } from "../../interfaces/internal/UserType";
import { Dropdown, Form, InputGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useBlade } from "../../services/BladeProvider";
// import {blades,setUserType} from "../../services/BladeProvider"
interface Props {
  userType?: UserTypes | undefined;
  onExit: () => void;
}

// TvSpotter = 1,
//TvCommentator = 2,
//Speaker = 11,
//Trainer = 21,
//Spectator = 31,
export function GetUserTypeNammes(usr: UserTypes | null): string {
  if (usr === null) {
    return "";
  }
  switch (usr) {
    case UserTypes.Speaker: {
      return "Speaker";
    }
    case UserTypes.Spectator: {
      return "Spectator";
    }
    case UserTypes.Trainer: {
      return "Trainer";
    }
    case UserTypes.TvCommentator: {
      return "TV-Commenator";
    }
    case UserTypes.TvSpotter: {
      return "TV-Spotter";
    }
    case UserTypes.TvCommentatorNoPreTime: {
      return "TV-Commenator (no pretime)";
    }    
    case UserTypes.SpeakerNoPreTime: {
      return "Speaker (no pretime)";
    }

  }
}

const UserTypChooice = ({ userType, onExit }: Props) => {
  const { blades, setUserType,setAccesToken,getAccesToken } = useBlade();
  const [user, setUser] = useState<UserTypes | undefined>(userType);
  const [accesTokenlocal, setAccesTokenlocal] = useState<string>(getAccesToken);

  const userTypeChanged = (usr: UserTypes) => {
    setUser(usr);
    if (usr < 3) {
      console.log(usr);
    }
  };
  const onSave = () => {
    if (user !== undefined) {
      localStorage.setItem("user_token", accesTokenlocal);
      setUserType(user);
      setAccesToken(accesTokenlocal)
      onExit();
    }
  };
  const onChange = (inp:string) => {
    setAccesTokenlocal(inp);
  };
  return (
    <div
      className="modal show"
      style={{
        display: "block",
        position: "absolute",
        background: "rgb(0 0 0 / 30%)",
      }}
    >
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>
            Choose user type (Beta - functionalities subject to change)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="usertype-box">
          <Dropdown>
            <div>
              <ol>
                <li>
                  <strong>{GetUserTypeNammes(UserTypes.Spectator)}: </strong>
                  For those who are watching on TV or in the arena. Provides all
                  the basics.
                </li>
                <li>
                  <strong>{GetUserTypeNammes(UserTypes.Trainer)}: </strong>
                  For trainers in the arena. Future updates will offer tools to
                  assist in pacing work.
                </li>
                <li>
                  <strong>{GetUserTypeNammes(UserTypes.Speaker)}: </strong>
                  For arena speakers.
                </li>
                <li>
                  <strong>
                    {GetUserTypeNammes(UserTypes.TvCommentator)}:{" "}
                  </strong>
                  For TV commentators.
                </li>
                <li>
                  <strong>{GetUserTypeNammes(UserTypes.TvSpotter)}: </strong>
                  For spotters, who assist TV-producer in deciding what to show.
                </li>
              </ol>
            </div>

            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basic"
              className="btn-"
              style={{ width: "100%" }}
            >
              {user === undefined ? "Choose usertype" : GetUserTypeNammes(user)}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: "100%" }}>
              <Dropdown.Item
                onClick={() => userTypeChanged(UserTypes.Spectator)}
              >
                {GetUserTypeNammes(UserTypes.Spectator)}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => userTypeChanged(UserTypes.Trainer)}>
                {GetUserTypeNammes(UserTypes.Trainer)}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => userTypeChanged(UserTypes.Speaker)}>
                {GetUserTypeNammes(UserTypes.Speaker)}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => userTypeChanged(UserTypes.SpeakerNoPreTime)}>
                {GetUserTypeNammes(UserTypes.SpeakerNoPreTime)}
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item
                onClick={() => userTypeChanged(UserTypes.TvCommentator)}
              >
                {GetUserTypeNammes(UserTypes.TvCommentator)}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => userTypeChanged(UserTypes.TvCommentatorNoPreTime)}
              >
                {GetUserTypeNammes(UserTypes.TvCommentatorNoPreTime)}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => userTypeChanged(UserTypes.TvSpotter)}
              >
                {GetUserTypeNammes(UserTypes.TvSpotter)}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {user && user < 4 ? (
            <>
          <br />
            <InputGroup className="mb-3">
              <InputGroup.Text id="inputGroup-sizing-default">
                Accestoken
              </InputGroup.Text>
              <Form.Control
                aria-label="Default"
                aria-describedby="inputGroup-sizing-default"
                onChange={e => setAccesTokenlocal(e.target.value)}
                value={accesTokenlocal}
              />
            </InputGroup></>) : null}
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
          <Button variant="primary" onClick={onExit}>
            Exit
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

export default UserTypChooice;
